/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const FileBookmark16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            fillRule="evenodd"
            d="M8.938 10.495c.242-.243.522-.301.772-.065s.177.529-.065.772l-.745.745c-1.377 1.376-3.538 1.2-4.841-.109-1.295-1.298-1.48-3.46-.12-4.817l.735-.738c.242-.243.55-.34.8-.103.25.236.169.538-.074.78l-.736.737c-.957.961-.93 2.4.102 3.434 1.03 1.035 2.48 1.06 3.402.133l.77-.77zm1.557-1.557l.77-.77c.925-.922.901-2.372-.134-3.402-1.034-1.031-2.473-1.06-3.434-.102l-.736.736c-.243.243-.545.324-.781.074s-.14-.558.103-.8l.738-.735c1.357-1.36 3.519-1.175 4.817.12 1.308 1.303 1.485 3.464.109 4.84l-.745.746c-.243.242-.536.314-.772.065-.236-.25-.178-.53.065-.772zm-3.519.695c-.243.243-.598.282-.794.087-.195-.196-.156-.551.087-.795l2.655-2.654c.243-.243.599-.282.794-.087.195.195.156.55-.087.794L6.976 9.633z"
        />
    </AccessibleSVG>
);

export default FileBookmark16;
